// extracted by mini-css-extract-plugin
export default {"mobileCheckoutWrapper":"FRT5h","mobileCheckoutHeader":"bopui","mobileCheckoutDivider":"mWItE"};